import React from 'react';
import { TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

/**
 * PartySelect - dropdown for selecting a political party.
 * @param {Object} props
 * @param {string} props.value - selected party key
 * @param {Function} props.onChange - called with party key on change
 * @param {Array<{key: string, name: string}>} props.partyOptions - array of Party ({ key, name }). Required.
 */
const PartySelect = ({ value, onChange, style, className, size, partyOptions }) => {
  const optionsToRender = (partyOptions || []).map((p) => ({ label: p.name, value: p.key }));

  return (
    <TextField
      select
      name="party"
      onChange={(e) => {
        onChange(e.target.value);
      }}
      style={style}
      className={className}
      value={value}
      size={size || 'medium'}
    >
      {optionsToRender.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export { PartySelect };
